export default {
  terms: [],
  tags: [],
  total: 0,
  filter: null,
  asets: [],
  tasks: [],
  max_range: 0,
  state_range: null,
  current_page: 0,
  from: 0,
  last_page: 0,
  per_page: 0,
  to: 0,
  total_page: 0,

  akumulasis: [],
  akumulasi_total: 0
}